import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mountain, Menu, X, Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { companyInfo } from '../../data/mockData';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/trekking', label: 'Trekking' },
    { path: '/cycling-tours', label: 'Cycling Tours' },
    { path: '/mountain-biking', label: 'Mountain Biking' },
    { path: '/ski-tours', label: 'Ski Tours' },
    { path: '/culture-tours', label: 'Culture Tours' },
    { path: '/nature-treat-hut', label: 'Nature Hut' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/about', label: 'About Us' },
    { path: '/payment', label: 'Payment Details'},
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <div className="group-hover:scale-105 transition-transform">
               <img
               src="/favicon.jpeg"
               alt="Magic Mountain Adventures"
               className="h-10 w-10 object-contain"
               />
            </div>

            <div className="hidden sm:block">
              <span className="font-bold text-lg text-emerald-800">Magic Mountain</span>
              <span className="text-xs block text-emerald-600 -mt-1">Adventures</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.slice(0, 8).map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-all ${
                  isActive(link.path)
                    ? 'bg-emerald-100 text-emerald-700'
                    : 'text-gray-700 hover:bg-emerald-50 hover:text-emerald-600'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Right side */}
          <div className="flex items-center gap-3">
            <Link to="/about" className="hidden lg:block text-sm font-medium text-gray-700 hover:text-emerald-600">
              About
            </Link>
<Link to="/payment">
  <Button
    variant="outline"
    className="hidden lg:flex border-emerald-600 text-emerald-700 hover:bg-emerald-50"
  >
    Payment
  </Button>
</Link>

<Link to="/contact">
  <Button className="hidden sm:flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700">
    <Phone className="h-4 w-4" />
    Contact
  </Button>
</Link>

            
            {/* Mobile menu button */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="lg:hidden bg-white border-t shadow-lg max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-3 rounded-lg font-medium transition-all ${
                  isActive(link.path)
                    ? 'bg-emerald-100 text-emerald-700'
                    : 'text-gray-700 hover:bg-emerald-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-3 border-t mt-3">
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center gap-2 px-4 py-3 text-emerald-600 font-medium"
              >
                <Phone className="h-5 w-5" />
                {companyInfo.phone}
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
